module.exports = __webpack_public_path__ + "img/portada-consultoria.f1b56e42.webp";